import { useEffect, useRef, useState } from "react";

import Ep62Img from "../../assets/images/conversations/ep-62-peter-varghese.webp";
import Ep61Img from "../../assets/images/conversations/ep-61-montek-singh-ahluwalia.webp";
import Ep60Img from "../../assets/images/conversations/ep-60-thirumalai-nc.webp";
import Ep59Img from "../../assets/images/conversations/ep-59-women-leaders.webp";
import Ep58Img from "../../assets/images/conversations/ep-58-Philip-GREEN.webp";
import Ep57Img from "../../assets/images/conversations/ep-57-Vijay-Gokhale.webp";
import Ep56Img from "../../assets/images/conversations/ep-56-Ranjit-Kulkarni.webp";
import Ep55Img from "../../assets/images/conversations/ep-55-Amitabh-Kant.webp";
import Ep54Img from "../../assets/images/conversations/ep-54-Pratik-Gupta.webp";
import Ep53Img from "../../assets/images/conversations/ep-53-Shardul-Kulkarni.webp";
import Ep52Img from "../../assets/images/conversations/ep-52-Uday-Narang.webp";
import Ep51Img from "../../assets/images/conversations/ep-51-Sudhir-Mehta.webp";
import Ep50Img from "../../assets/images/conversations/ep-50-Vijay-Gokhale.webp";
import Ep49Img from "../../assets/images/conversations/ep-49-EV-Charger-OEMs.webp";
import Ep48Img from "../../assets/images/conversations/ep-48-Amara-Raja.webp";
import Ep47Img from "../../assets/images/conversations/ep-47-EMotorad.webp";
import Ep46Img from "../../assets/images/conversations/ep-46-Akshay-Singhal.webp";
import Ep45Img from "../../assets/images/conversations/ep-45-Sheetanshu-Tyagi.webp";
import Ep44Img from "../../assets/images/conversations/ep-44-Luca-Fontanelli.webp";
import Ep42Img from "../../assets/images/conversations/ep-42-Siddharth-Mayur.webp";
import Ep41Img from "../../assets/images/conversations/ep-41-Manish-Jain.webp";
import Ep40Img from "../../assets/images/conversations/ep-40-Vasudha-Madhavan.webp";
import Ep38Img from "../../assets/images/conversations/ep-38-Amara-Raja-Batteries.webp";
import Ep37Img from "../../assets/images/conversations/ep-37-Fyn.webp";
import Ep36Img from "../../assets/images/conversations/ep-36-Vayve-Mobility.webp";
import Ep34Img from "../../assets/images/conversations/ep-34-Kapil-Shelke.webp";
import Ep33Img from "../../assets/images/conversations/ep-33-Green-Hydrogen.webp";
import Ep32Img from "../../assets/images/conversations/ep-32-MG.webp";
import Ep31Img from "../../assets/images/conversations/ep-31-EV-Super-User.webp";
import Ep29Img from "../../assets/images/conversations/ep-29-Ravi-Panga.webp";
import Ep28Img from "../../assets/images/conversations/ep-28-Preeti-Bajaj.webp";
import Ep27Img from "../../assets/images/conversations/ep-27-Awadesh-Jha.webp";
import Ep26Img from "../../assets/images/conversations/ep-26-Karthikeyan-Palanisamy.webp";
import Ep25Img from "../../assets/images/conversations/ep-25-Vijay-Vaitheeswaran.webp";
import Ep24Img from "../../assets/images/conversations/ep-24-Dhwal-Khullar.webp";
import Ep23Img from "../../assets/images/conversations/ep-23-Uday-Narang.webp";
import Ep21Img from "../../assets/images/conversations/ep-21-Arun-Vinayak.webp";
import Ep20Img from "../../assets/images/conversations/ep-20-kartikey-Hariyani.webp";
import Ep19Img from "../../assets/images/conversations/ep-19-Cyrus-Dhabar.webp";
import Ep18Img from "../../assets/images/conversations/ep-18-Rajeev-Chaba.webp";
import Ep17Img from "../../assets/images/conversations/ep-17-KR-Jyothilal.webp";
import Ep16Img from "../../assets/images/conversations/ep-16-Alisha-Sachdev.webp";
import Ep15Img from "../../assets/images/conversations/ep-15-Sajid-Mubshir.webp";
import Ep14Img from "../../assets/images/conversations/ep-14-Nishant-Arya.webp";
import Ep12Img from "../../assets/images/conversations/ep-12-kartikey-Hariyani.webp";
import Ep11Img from "../../assets/images/conversations/ep-11-Gaurav-Gupta.webp";
import Ep10Img from "../../assets/images/conversations/ep-10-Naveen-Munjal.webp";
import Ep09Img from "../../assets/images/conversations/ep-09-Nikita-Nishita.webp";
import Ep07Img from "../../assets/images/conversations/ep-07-Reji-Kumar.webp";
import Ep06Img from "../../assets/images/conversations/ep-06-Mahesh-Babu.webp";
import Ep04Img from "../../assets/images/conversations/ep-04-Sulajja-Motwani.webp";
import Ep03Img from "../../assets/images/conversations/ep-03-Tarun-Mehta.webp";
import Ep02Img from "../../assets/images/conversations/ep-02-Stefan-Louis.webp";
import Ep01Img from "../../assets/images/conversations/ep-01-Stefan-Louis.webp";

import { ReactComponent as ConversationsPlayIcon } from "../../assets/icons/conversations/conversations-play.svg";
import { ReactComponent as ConversationsHeadphonesIcon } from "../../assets/icons/conversations/conversations-headphones.svg";

import ConversationsMobileImg  from "../../assets/images/conversations/phone-mockup.webp";
import ConversationsMicLogo    from "../../assets/images/conversations/podcast-mic-logo.webp";
import ConversationsSpotifyBtn from "../../assets/images/conversations/conversations-spotify-btn.webp";
import ConversationsAppleBtn   from "../../assets/images/conversations/conversations-apple-btn.webp";
import GuestGauravImg          from "../../assets/images/conversations/guest-gaurav-gupta.webp";
import GuestVijayGokhaleImg    from "../../assets/images/conversations/guest-vijay-gokhale.webp";
import GuestShardulImg         from "../../assets/images/conversations/guest-sharadul-kukarni.webp";
import GuestAmitabhImg         from "../../assets/images/conversations/guest-amitabh-kant.webp";
import GuestRanjitImg          from "../../assets/images/conversations/guest-ranjit-kulkarni.webp";
import GuestVijayVImg          from "../../assets/images/conversations/guest-vijay-vaitheeswaran.webp";

const SPOTIFY_EMBEDS = [
  "https://open.spotify.com/embed/episode/2sJHuNlCqpLxC97yUpjtwf?utm_source=generator",
  "https://open.spotify.com/embed/show/31CpjZm9DyfCR7sstBZlIf?utm_source=generator&theme=0",
  "https://open.spotify.com/embed/episode/7odcCzjGUqXdsNJmSbA9rf?utm_source=generator&theme=0",
  "https://open.spotify.com/embed/episode/122EvNLroaFoZHlWxF3MHa?utm_source=generator&theme=0",
  "https://open.spotify.com/embed/episode/11ST3TaMSBF2nmb3yULpA4?utm_source=generator&theme=0",
];

const GUESTS = [
  { img: GuestGauravImg,       name: "Gaurav GUPTA" },
  { img: GuestVijayGokhaleImg, name: "Vijay GOKHALE" },
  { img: GuestShardulImg,      name: "Sharadul KUKARNI" },
  { img: GuestAmitabhImg,      name: "Amitabh KANT" },
  { img: GuestRanjitImg,       name: "Ranjit KULKARNI" },
  { img: GuestVijayVImg,       name: "Vijay VAITHEESWARAN" },
];

const CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@400;500;600;700;800&family=Roboto:wght@400;500&display=swap');

  *, *::before, *::after { margin: 0; padding: 0; box-sizing: border-box; }

  .cv-page {
    background: #1A1A1A;
    min-height: 100vh;
    font-family: 'Roboto', sans-serif;
    color: #fff;
    overflow-x: hidden;
  }

  .cv-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }

  /* ══════════════════════════════════════════
     SECTION 1: HERO
  ══════════════════════════════════════════ */
  .cv-hero {
    background: #1A1A1A;
    text-align: center;
    padding: 60px 0 80px;
  }
  .cv-hero__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 100px;
    font-weight: 700;
    color: #fff;
    line-height: 140%;
    letter-spacing: 1%;
  }
  .cv-hero__title span {
    display: block;
    font-weight: 700;
    font-size: 100px;
    letter-spacing: 1%;
  }
  .cv-hero__mic {
    margin: 24px auto 100px;
    width: 366px;
    display: block;
  }

  /* ── CAROUSEL ── */
  .cv-carousel {
    position: relative;
    overflow: hidden;
    cursor: grab;
    user-select: none;
    -webkit-user-select: none;
    touch-action: none;
  }
  .cv-carousel.cv-dragging { cursor: grabbing; }
  .cv-carousel__track {
    display: flex;
    will-change: transform;
    transition: transform 0.45s cubic-bezier(0.25, 0.46, 0.45, 0.94);
  }
  .cv-ep-card {
    display: flex;
    flex-direction: column;
    text-align: left;
  }
  .cv-ep-card__img-wrap {
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    background: #2a1a3e;
    display: block;
  }
  .cv-ep-card__img-wrap img {
    width: 100%;
    height: 300px;
    object-fit: cover;
    display: block;
    pointer-events: none;
  }
  .cv-ep-card__below {
    display: flex;
    align-items: flex-start;
    gap: 14px;
    margin-top: 20px;
    padding: 0 2px;
    text-decoration: none;
    color: inherit;
  }
  .cv-ep-card__play svg {
    flex-shrink: 0;
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0px;
  }
  .cv-ep-card__title {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #fff;
    line-height: 140%;
  }

  /* ── CARD BADGE ── */
  .cv-card-img-wrap { position: relative; }
  .cv-card-badge {
    position: absolute;
    top: 10px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    gap: 6px;
    background: linear-gradient(to right, #3D1E4B 0%, #5F1733 100%);
    border-radius: 10px;
    padding: 10px 71px 10px 71px;
    font-family: 'Roboto', sans-serif;
    font-size: 18px;
    font-weight: 400;
    color: #fff;
    white-space: nowrap;
    z-index: 2;
  }
  .cv-card-badge svg { flex-shrink: 0; }

  /* ── HERO DIVIDER ── */
  .cv-hero__divider {
    width: 100%;
    height: 1px;
    background: #4C4C4C;
    margin-top: 80px;
    max-width: 1396px;
    margin: 80px auto 0;
  }

  /* ── DOTS ── */
  .cv-dots {
    display: flex;
    justify-content: center;
    gap: 8px;
    margin-top: 46px;
  }
  .cv-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #3C3C3C;
    border: none;
    padding: 0;
    cursor: pointer;
    transition: background 0.3s, transform 0.3s;
  }
  .cv-dot.cv-dot--active {
    background: #743FAC;
    transform: scale(1.2);
  }

  /* ══════════════════════════════════════════
     SECTION 2: TOP 6 TRENDING
  ══════════════════════════════════════════ */
  .cv-trending {
    background: #1A1A1A;
    padding: 0px 0 80px;
  }
  .cv-section-label {
    font-family: 'Montserrat', sans-serif;
    font-size: 24px;
    font-weight: 500;
    color: #FFFFFF;
    text-align: center;
    letter-spacing: 1%;
    margin-bottom: 14px;
  }
  .cv-section-title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #fff;
    text-align: center;
    margin-bottom: 14px;
    line-height: 120%;
  }
  .cv-section-sub {
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    color: #FFFFFF;
    text-align: center;
    margin-bottom: 44px;
    max-width: 882px;
    margin-left: auto;
    margin-right: auto;
  }
  .cv-grid-3 {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 70px;
    column-gap: 30px;
  }

  /* ── SIMPLE CARD ── */
  .cv-simple-card {
    display: flex;
    flex-direction: column;
    opacity: 0;
    transform: translateY(36px);
    transition: opacity 0.65s ease, transform 0.65s ease;
  }
  .cv-simple-card.cv-visible { opacity: 1; transform: translateY(0); }
  .cv-simple-card:nth-child(2) { transition-delay: 0.08s; }
  .cv-simple-card:nth-child(3) { transition-delay: 0.16s; }
  .cv-simple-card:nth-child(4) { transition-delay: 0.08s; }
  .cv-simple-card:nth-child(5) { transition-delay: 0.16s; }
  .cv-simple-card:nth-child(6) { transition-delay: 0.24s; }
  .cv-simple-card__link {
    position: relative;
    border-radius: 12px;
    overflow: hidden;
    background: #2a1a3e;
    display: block;
    text-decoration: none;
    transition: transform 0.35s ease, box-shadow 0.35s ease;
  }
  .cv-simple-card__link:hover {
    transform: translateY(-4px);
    box-shadow: 0 16px 48px rgba(116, 63, 172, 0.35);
  }
  .cv-simple-card__link img {
    width: 100%;
    height: 300px;
    object-fit: cover;
    display: block;
  }
  .cv-simple-card__below {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    margin-top: 14px;
    padding: 0 2px;
    text-decoration: none;
    color: inherit;
  }
  .cv-simple-card__play svg {
    flex-shrink: 0;
    width: 34px;
    height: 34px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cv-simple-card__title {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 140%;
  }

  /* ── TRENDING DIVIDER ── */
  .cv-trending__divider {
    width: 100%;
    height: 1px;
    background: #4C4C4C;
    max-width: 1396px;
    margin: 80px auto 0;
  }

  /* ══════════════════════════════════════════
     SECTION 3: MOBILE STREAM
  ══════════════════════════════════════════ */
  .cv-mobile {
    background: #1A1A1A;
    padding: 0;
  }
  .cv-mobile__img-wrap {
    width: 647px;
    line-height: 0;
    margin: 0 auto;
  }
  .cv-mobile__img-wrap img {
    width: 100%;
    display: block;
    object-fit: cover;
  }
  .cv-mobile__content {
    max-width: 1600px;
    margin: 0 auto;
    padding: 100px 102px;
    text-align: center;
  }
  .cv-mobile__label {
    font-family: 'Montserrat', sans-serif;
    font-size: 24px;
    color: #FFFFFF;
    letter-spacing: 1%;
    margin-bottom: 14px;
    display: block;
  }
  .cv-mobile__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #fff;
    line-height: 120%;
    margin-bottom: 14px;
  }
  .cv-mobile__desc {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    color: #FFFFFF;
    line-height: 120%;
    margin-bottom: 60px;
    max-width: 1146px;
    margin-left: auto;
    margin-right: auto;
  }
  .cv-mobile__btns {
    display: flex;
    gap: 44px;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
  }
  .cv-mobile__btns a { display: block; }
  .cv-mobile__btns img { height: 80px; width: auto; display: block; }

  @media (max-width: 768px) {
    .cv-mobile__content { padding: 24px 32px; }
    .cv-mobile__title { font-size: 24px; }
  }
  @media (max-width: 480px) {
    .cv-mobile__content { padding: 60px 16px 38px 16px; }
    .cv-mobile__title { font-size: 30px; }
  }

  /* ══════════════════════════════════════════
     SECTION 4: TABS + LATEST EPISODES
  ══════════════════════════════════════════ */
  .cv-latest {
    background: #1A1A1A;
    padding: 0 0 100px;
  }
  .cv-tabs {
    display: flex;
    gap: 30px;
    justify-content: center;
    flex-wrap: wrap;
  }
  .cv-tab {
    flex: 1;
    padding: 33px 30px;
    border-radius: 10px;
    border: 1px solid #743FAC;
    background: transparent;
    color: #fff;
    font-family: 'Montserrat', sans-serif;
    font-size: 20px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.25s;
    text-align: center;
    line-height: 1.3;
    max-width: 255px;
    text-decoration: none;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .cv-tab:hover { border-color: #743FAC; background: rgba(116,63,172,0.15); }
  .cv-tab.cv-tab--active { background: #743FAC; border-color: #743FAC; color: #fff; }
  .cv-tab__sub {
    display: none;
    font-family: 'Roboto', sans-serif;
    font-size: 14px;
    font-weight: 400;
    opacity: 0.85;
    margin-top: 4px;
    text-decoration: underline;
    line-height: 1;
    white-space: nowrap;
  }
  .cv-tab.cv-tab--active .cv-tab__sub { display: block; }
  .cv-tab:hover .cv-tab__sub { display: block; }
  .cv-latest__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 60px;
    margin-top: 100px;
  }
  @media (max-width: 480px) {
    .cv-latest__header { flex-direction: column; align-items: flex-start; gap: 20px; }
    .cv-latest__viewall { width: 100%; justify-content: center; text-align: center; white-space: nowrap; }
  }
  .cv-tabs-wrap {
    background: #000;
    width: 100%;
    padding: 80px 0 80px;
  }
  .cv-tabs-inner {
    max-width: 1600px;
    margin: 0 auto;
    padding: 0 102px;
  }
  .cv-latest__heading {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #fff;
  }
  .cv-latest__viewall {
    display: inline-flex;
    align-items: center;
    gap: 8px;
    background: #743FAC;
    color: #fff;
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 500;
    padding: 15px 30px;
    border-radius: 5px;
    text-decoration: none;
    transition: background 0.2s;
  }
  .cv-latest__viewall:hover { background: #9B5FD4; }

  /* ══════════════════════════════════════════
     SECTION 5: SPOTIFY IFRAMES
  ══════════════════════════════════════════ */
  .cv-spotify {
    background: #1A1A1A;
    padding: 0px 0 100px;
  }
  .cv-spotify__list {
    display: flex;
    flex-direction: column;
    gap: 60px;
  }
  .cv-spotify__iframe {
    width: 100%;
    border-radius: 12px;
    border: none;
    display: block;
    height: 352px;
  }
  .cv-spotify__row2 {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 30px;
  }
  .cv-spotify__row2 .cv-spotify__iframe { width: 100%; }

  /* ══════════════════════════════════════════
     SECTION 6: FEATURED SHOWS + GUESTS
  ══════════════════════════════════════════ */
  .cv-featured {
    background: #1A1A1A;
    padding: 70px 0 100px;
  }
  .cv-featured__label {
    font-family: 'Roboto', sans-serif;
    font-size: 24px;
    font-weight: 400;
    color: #fff;
    text-align: center;
    margin-bottom: 14px;
  }
  .cv-featured__title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #fff;
    text-align: center;
    margin-bottom: 60px;
  }
  .cv-featured__stats {
    display: flex;
    gap: 0;
    padding: 0px 0 80px;
    margin-bottom: 0;
    border-bottom: 1px solid #333;
  }
  .cv-stat {
    flex: 1;
    text-align: center;
    border-right: 1px solid #4C4C4C;
    padding: 0 20px;
  }
  .cv-stat:first-child { border-left: none; }
  .cv-stat:last-child { border-right: none; }
  .cv-stat__num {
    font-family: 'Montserrat', sans-serif;
    font-size: 40px;
    font-weight: 700;
    color: #fff;
    display: block;
    line-height: 120%;
  }
  .cv-stat__label {
    font-family: 'Montserrat', sans-serif;
    font-size: 24px;
    color: #FFFFFF;
    margin-top: 4px;
    display: block;
  }
  .cv-guest-label {
    font-family: 'Roboto', sans-serif;
    font-size: 16px;
    font-weight: 400;
    color: #FFFFFF;
    text-align: center;
    margin-bottom: 0;
    order: 2;
  }
  .cv-guest-title {
    font-family: 'Montserrat', sans-serif;
    font-size: 50px;
    font-weight: 700;
    color: #fff;
    text-align: center;
    margin-bottom: 8px;
    order: 1;
  }
  .cv-guest-header {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 60px;
    margin-top: 100px;
  }
  .cv-guest__grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    row-gap: 60px;
    column-gap: 30px;
  }
  .cv-guest-card {
    display: flex;
    flex-direction: column;
    cursor: pointer;
    opacity: 0;
    transform: translateY(36px);
    transition: opacity 0.65s ease, transform 0.65s ease;
  }
  .cv-guest-card.cv-visible { opacity: 1; transform: translateY(0); }
  .cv-guest-card:nth-child(2) { transition-delay: 0.08s; }
  .cv-guest-card:nth-child(3) { transition-delay: 0.16s; }
  .cv-guest-card:nth-child(4) { transition-delay: 0.08s; }
  .cv-guest-card:nth-child(5) { transition-delay: 0.16s; }
  .cv-guest-card:nth-child(6) { transition-delay: 0.24s; }
  .cv-guest-card:hover .cv-guest-card__img { box-shadow: 0 16px 48px rgba(116,63,172,0.55); }
  .cv-guest-card__img {
    border-radius: 12px;
    overflow: hidden;
    background: #743FAC;
    transition: box-shadow 0.35s ease;
  }
  .cv-guest-card__img img {
    width: 100%;
    height: 500px;
    object-fit: cover;
    display: block;
  }
  .cv-guest-card__name {
    font-family: 'Montserrat', sans-serif;
    font-size: 24px;
    font-weight: 700;
    color: #fff;
    text-align: center;
    margin-top: 24px;
    padding: 0;
    background: transparent;
  }

  /* ══════════════════════════════════════════
     RESPONSIVE
  ══════════════════════════════════════════ */
  @media (max-width: 768px) {
    .cv-inner,
    .cv-mobile__inner { padding: 0 32px; }
    .cv-hero { padding: 32px 0 40px; }
    .cv-hero__title { font-size: 32px; }
    .cv-hero__title span { font-size: 32px; }
    .cv-hero__mic { margin: 24px auto 40px; width: 250px; font-size: 14px; }
    .cv-card-badge { padding: 5px 30px 5px 30px; }
    .cv-ep-card__title { font-size: 14px; }
    .cv-ep-card__play svg { width: 24px; height: 24px; }
    .cv-ep-card__img-wrap img { height: 220px; }
    .cv-section-title { font-size: 32px; }
    .cv-dots { margin-top: 16px; }
    .cv-hero__divider { margin: 40px auto 0; }
    .cv-section-sub { margin-bottom: 24px; }
    .cv-grid-3 { grid-template-columns: repeat(2, 1fr); row-gap: 40px; column-gap: 24px; }
    .cv-simple-card__link img { height: 220px; }
    .cv-trending { padding: 0px 0 40px; }
    .cv-mobile__img-wrap { width: 350px; }
    .cv-trending__divider { margin: 40px auto 0; }
    .cv-simple-card__title { font-size: 14px; }
    .cv-simple-card__play svg { width: 24px; height: 24px; }
    .cv-guest__grid { grid-template-columns: repeat(2, 1fr); row-gap: 32px; column-gap: 24px; }
    .cv-featured__stats { flex-wrap: wrap; row-gap: 20px; padding: 0px 0 40px; }
    .cv-stat { flex: 0 0 50%; margin-bottom: 20px; }
    .cv-mobile__desc { margin-bottom: 32px; }
    .cv-mobile__btns img { height: 60px; }
    .cv-tabs-inner { padding: 0 32px; }
    .cv-tabs-wrap { padding: 32px 0 32px; }
    .cv-tabs { gap: 24px; }
    .cv-tab { max-width: 120px; padding: 24px 24px; font-size: 16px; }
    .cv-latest__header { margin-bottom: 32px; margin-top: 40px; }
    .cv-latest__heading { font-size: 32px; }
    .cv-latest { padding: 0 0 40px; }
    .cv-spotify__iframe { height: 250px; }
    .cv-spotify__list { gap: 30px; }
    .cv-spotify { padding: 0px 0 40px; }
    .cv-featured__title { font-size: 32px; margin-bottom: 24px; }
    .cv-stat__num { font-size: 28px; }
    .cv-stat__label { font-size: 16px; }
    .cv-guest-header { margin-bottom: 24px; margin-top: 40px; }
    .cv-guest-title { font-size: 32px; }
    .cv-guest-card__img img { height: 320px; }
    .cv-guest-card__name { font-size: 20px; margin-top: 20px; }
    .cv-featured { padding: 0px 0 48px; }
  }

  @media (max-width: 480px) {
    .cv-inner,
    .cv-mobile__inner { padding: 0 16px; }
    .cv-hero { padding: 51px 0 60px; }
    .cv-hero__mic { margin: 50px auto 50px; width: 214px; font-size: 14px; }
    .cv-ep-card__title { font-size: 14px; }
    .cv-dots { margin-top: 14px; }
    .cv-ep-card__play svg { width: 24px; height: 24px; }
    .cv-hero__divider { margin: 50px auto 0; }
    .cv-section-label { font-size: 16px; margin-bottom: 16px; }
    .cv-hero__title { font-size: 36px; line-height: 120%; }
    .cv-hero__title span { font-size: 30px; }
    .cv-grid-3 { grid-template-columns: 1fr; gap: 30px; }
    .cv-guest__grid { grid-template-columns: 1fr; }
    .cv-section-title { font-size: 30px; margin-bottom: 15px; }
    .cv-tabs { gap: 12px; flex-direction: column; align-items: stretch; }
    .cv-tab { max-width: 100%; width: 100%; padding: 25px 20px; font-size: 16px; }
    .cv-stat { flex: 0 0 50%; }
    .cv-section-sub { margin-bottom: 24px; font-size: 14px; }
    .cv-simple-card__link img { height: 374px; }
    .cv-card-badge { padding: 5px 50px 5px 50px; }
    .cv-simple-card__title { font-size: 14px; }
    .cv-trending__divider { margin: 50px auto 0; }
    .cv-mobile__img-wrap { width: 370px; }
    .cv-trending { padding: 0px 0 60px; }
    .cv-mobile__label { font-size: 16px; }
    .cv-mobile__desc { margin-bottom: 15px; font-size: 14px; }
    .cv-mobile__btns { gap: 20px; }
    .cv-mobile__btns img { height: 44px; }
    .cv-latest__header { margin-bottom: 20px; margin-top: 40px; }
    .cv-latest__heading { font-size: 30px; text-align: center; }
    .cv-latest__viewall { padding: 11.5px 30px; font-size: 14px; }
    .cv-spotify__iframe { height: 160px; }
    .cv-spotify__list { gap: 20px; }
    .cv-spotify__row2 { grid-template-columns: 1fr; gap: 20px; }
    .cv-featured__label { font-size: 16px; }
    .cv-featured__title { font-size: 30px; margin-bottom: 40px; }
    .cv-stat__num { font-size: 40px; }
    .cv-stat__label { font-size: 24px; }
    .cv-guest-header { margin-bottom: 30px; margin-top: 50px; }
    .cv-guest-title { font-size: 30px; margin-bottom: 15px; }
    .cv-guest-label { font-size: 14px; }
    .cv-guest-card__img img { height: 390px; }
    .cv-guest-card__name { font-size: 20px; margin-top: 24px; }
    .cv-featured { padding: 0px 0 40px; }
    .cv-ep-card__img-wrap img { height: 374px; }

  }
`;

/* ─────────────────────────────────────────────
   DATA
───────────────────────────────────────────── */
const HERO_EPISODES = [
  { img: Ep62Img, ep: "Ep 62", title: "EP 62 | Peter VARGHESE on China's Tech Dominance, Trump's America, & the India-Australia Partnership.", href: "/ep-62-peter-varghese-on-chinas-tech-dominance-trumps-america-the-india-australia-partnership-duplicate-5969/" },
  { img: Ep61Img, ep: "Ep 61", title: "EP 61 | 1991: India's Near-Default Moment. How Did We Survive — and in 2025 What Challenges Come Next? | Montek Singh AHLUWALIA", href: "/ep-61-1991-indias-near-default-moment-how-did-we-survive-and-in-2025-what-challenges-come-next-montek-singh-ahluwalia-duplicate-5415/" },
  { img: Ep60Img, ep: "Ep 60", title: "EP 60 | Bangalore's pollution — a victim of its own economic success. Can EVs change that? Thirumalai NC", href: "/ep60bangalorepollution/" },
  { img: Ep59Img, ep: "Ep 59", title: "EP 59 | Women Leaders in Hydrogen — India", href: "/ep59womenleaderinhydrogen/" },
  { img: Ep58Img, ep: "Ep 58", title: "EP 58 | Australia & India: Adapting to the New Global Reality | Philip GREEN", href: "/ep58philipgreen/" },
  { img: Ep57Img, ep: "Ep 57", title: "EP 57 | Navigating Geopolitics in a Shifting World Order | Vijay GOKHALE", href: "/ep57vijayfhokhalegeo/" },
  { img: Ep56Img, ep: "Ep 56", title: "EP 56 | Fuels of the future with Honeywell | Ranjit KULKARNI", href: "/ep56honeywellranjitkulkarni/" },
  { img: Ep55Img, ep: "Ep 55", title: "EP 55 | Inside India's Journey Towards Energy Transition with Amitabh Kant", href: "/ep-55-inside-indias-journey-towards-energy-transition-with-amitabh-kant/" },
  { img: Ep54Img, ep: "Ep 54", title: "EP 54 | Decoding the Future of Urban Electric Mobility | Gensol EV | Pratik Gupta", href: "/ep-54-decoding-the-future-of-urban-electric-mobility-gensol-ev-pratik-gupta/" },
  { img: Ep53Img, ep: "Ep 53", title: "EP 53 | Industrial Decarbonisation with Green Hydrogen | Shardul Kulkarni", href: "/ep-53-industrial-decarbonisation-with-green-hydrogen-shardul-kulkarni/" },
  { img: Ep52Img, ep: "Ep 52", title: "EP 52 | Empowering Sustainable Last Mile Deliveries | Uday Narang", href: "/ep-52-empowering-sustainable-last-mile-deliveries-uday-narang/" },
  { img: Ep51Img, ep: "Ep 51", title: "EP 51 | Revolutionizing India's Buses: A Startup's Electric Impact | Sudhir Mehta | EKA & Pinnacle Industries", href: "/ep-51-revolutionizing-indias-buses-a-startups-electric-impact-sudhir-mehta-eka-pinnacle-industries/" },
  { img: Ep50Img, ep: "Ep 50", title: "EP 50 | Unwrapping geopolitics with Vijay GOKHALE", href: "/ep-50-unwrapping-geopolitics-with-vijay-gokhale/" },
];

const TRENDING_EPISODES = [
  { img: Ep55Img, ep: "Ep 55", title: "EP 55 | Inside India's Journey Towards Energy Transition with Amitabh Kant", href: "/ep-55-inside-indias-journey-towards-energy-transition-with-amitabh-kant/" },
  { img: Ep52Img, ep: "Ep 52", title: "EP 52 | Empowering Sustainable Last Mile Deliveries | Uday Narang", href: "/ep-52-empowering-sustainable-last-mile-deliveries-uday-narang/" },
  { img: Ep51Img, ep: "Ep 51", title: "EP 51 | Revolutionizing India's Buses: A Startup's Electric Impact | Sudhir Mehta", href: "/ep-51-revolutionizing-indias-buses-a-startups-electric-impact-sudhir-mehta-eka-pinnacle-industries/" },
  { img: Ep07Img, ep: "Ep 07", title: "E07 | Candid Conversation with Reji Kumar PILLAI, President of India Smart Grid Forum", href: "/e07-candid-conversation-with-reji-kumar-pillai-president-of-india-smart-grid-forum-on-charging-standards-in-india-the-power-grids-ability-to-accommodate-a-massive-move-to-e-mobility/" },
  { img: Ep62Img, ep: "Ep 62", title: "EP 62 | Peter VARGHESE on China's Tech Dominance, Trump's America, & the India-Australia Partnership.", href: "/ep-62-peter-varghese-on-chinas-tech-dominance-trumps-america-the-india-australia-partnership-duplicate-5969/" },
  { img: Ep61Img, ep: "Ep 61", title: "EP 61 | 1991: India's Near-Default Moment. How Did We Survive — and in 2025 What Challenges Come Next? | Montek Singh AHLUWALIA", href: "/ep-61-1991-indias-near-default-moment-how-did-we-survive-and-in-2025-what-challenges-come-next-montek-singh-ahluwalia-duplicate-5415/" },
];

const LATEST_EPISODES = [
  { img: Ep62Img, ep: "Ep 62", title: "EP 62 | Peter VARGHESE on China's Tech Dominance, Trump's America, & the India-Australia Partnership.", href: "/ep-62-peter-varghese-on-chinas-tech-dominance-trumps-america-the-india-australia-partnership-duplicate-5969/" },
  { img: Ep61Img, ep: "Ep 61", title: "EP 61 | 1991: India's Near-Default Moment. How Did We Survive — and in 2025 What Challenges Come Next? | Montek Singh AHLUWALIA", href: "/ep-61-1991-indias-near-default-moment-how-did-we-survive-and-in-2025-what-challenges-come-next-montek-singh-ahluwalia-duplicate-5415/" },
  { img: Ep60Img, ep: "Ep 60", title: "EP 60 | Bangalore's pollution — a victim of its own economic success. Can EVs change that? Thirumalai NC", href: "/ep60bangalorepollution/" },
  { img: Ep59Img, ep: "Ep 59", title: "EP 59 | Women Leaders in Hydrogen — India", href: "/ep59womenleaderinhydrogen/" },
  { img: Ep58Img, ep: "Ep 58", title: "EP 58 | Australia & India: Adapting to the New Global Reality | Philip GREEN", href: "/ep58philipgreen/" },
  { img: Ep57Img, ep: "Ep 57", title: "EP 57 | Navigating Geopolitics in a Shifting World Order | Vijay GOKHALE", href: "/ep57vijayfhokhalegeo/" },
  { img: Ep56Img, ep: "Ep 56", title: "EP 56 | Fuels of the future with Honeywell | Ranjit KULKARNI", href: "/ep56honeywellranjitkulkarni/" },
  { img: Ep55Img, ep: "Ep 55", title: "EP 55 | Inside India's Journey Towards Energy Transition with Amitabh Kant", href: "/ep-55-inside-indias-journey-towards-energy-transition-with-amitabh-kant/" },
  { img: Ep54Img, ep: "Ep 54", title: "EP 54 | Decoding the Future of Urban Electric Mobility | Gensol EV | Pratik Gupta", href: "/ep-54-decoding-the-future-of-urban-electric-mobility-gensol-ev-pratik-gupta/" },
  { img: Ep53Img, ep: "Ep 53", title: "EP 53 | Industrial Decarbonisation with Green Hydrogen | Shardul Kulkarni", href: "/ep-53-industrial-decarbonisation-with-green-hydrogen-shardul-kulkarni/" },
  { img: Ep52Img, ep: "Ep 52", title: "EP 52 | Empowering Sustainable Last Mile Deliveries | Uday Narang", href: "/ep-52-empowering-sustainable-last-mile-deliveries-uday-narang/" },
  { img: Ep51Img, ep: "Ep 51", title: "EP 51 | Revolutionizing India's Buses: A Startup's Electric Impact | Sudhir Mehta", href: "/ep-51-revolutionizing-indias-buses-a-startups-electric-impact-sudhir-mehta-eka-pinnacle-industries/" },
  { img: Ep50Img, ep: "Ep 50", title: "EP 50 | Unwrapping geopolitics with Vijay GOKHALE", href: "/ep-50-unwrapping-geopolitics-with-vijay-gokhale/" },
];

const TABS = [
  { label: "EV",              href: "/ev/" },
  { label: "Battery",         href: "/battery/" },
  { label: "Hydrogen",        href: "/hydrogen/" },
  { label: "Watts Happening", href: "/watts-happening/" },
  { label: "1.5° Diaries",    href: "#" },
];

/* ─────────────────────────────────────────────
   ICONS
───────────────────────────────────────────── */
function HeadphonesIcon() {
  return <ConversationsHeadphonesIcon width="13" height="13" style={{ flexShrink: 0 }} />;
}

function PlayIcon() {
  return <ConversationsPlayIcon width="9" height="9" style={{ marginLeft: 1 }} />;
}

function ArrowRight() {
  return (
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none">
      <path d="M3 8h10M9 4l4 4-4 4" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

/* ─────────────────────────────────────────────
   SIMPLE CARD
───────────────────────────────────────────── */
function SimpleCard({ img, ep, title, href }) {
  return (
    <div className="cv-simple-card">
      <div className="cv-simple-card__link">
        {img && <img src={img} alt={ep} />}
        <div className="cv-card-badge">
          <HeadphonesIcon />
          EV, Podcast, Top 6 episodes
        </div>
      </div>
      <a href={href} className="cv-simple-card__below" rel="noreferrer">
        <div className="cv-simple-card__play"><PlayIcon /></div>
        <p className="cv-simple-card__title">{title}</p>
      </a>
    </div>
  );
}

/* ─────────────────────────────────────────────
   CAROUSEL — responsive perView (1/2/3)
───────────────────────────────────────────── */
function Carousel({ episodes, autoplayMs }) {
  var GAP   = 30;
  var total = episodes.length;

  var getPerView = function() {
    if (window.innerWidth <= 480) return 1;
    if (window.innerWidth <= 768) return 2;
    return 3;
  };

  var buildCloned = function(pv) {
    return episodes.slice(-pv).concat(episodes).concat(episodes.slice(0, pv));
  };

  var [perView, setPerView]   = useState(getPerView());
  var [cloned,  setCloned]    = useState(function() { return buildCloned(getPerView()); });
  var [idx,     setIdx]       = useState(getPerView());

  var trackRef            = useRef(null);
  var wrapRef             = useRef(null);
  var dragStart           = useRef(null);
  var dragCurrent         = useRef(0);
  var isDragging          = useRef(false);
  var skipTransition      = useRef(false);
  var timerRef            = useRef(null);

  var cardW = function() {
    if (!wrapRef.current) return 0;
    return (wrapRef.current.offsetWidth - GAP * (perView - 1)) / perView;
  };

  var moveTo = function(i, animated) {
    var track = trackRef.current;
    if (!track) return;
    track.style.transition = animated
      ? "transform 0.45s cubic-bezier(0.25,0.46,0.45,0.94)"
      : "none";
    track.style.transform = "translateX(-" + (i * (cardW() + GAP)) + "px)";
  };

  useEffect(function() {
    moveTo(idx, !skipTransition.current);
    skipTransition.current = false;
  }, [idx, perView]);

  /* ── resize ── */
  useEffect(function() {
    var handler = function() {
      var v = getPerView();
      setPerView(v);
      setCloned(buildCloned(v));
      setIdx(v);
    };
    window.addEventListener("resize", handler);
    return function() { window.removeEventListener("resize", handler); };
  }, []);

  /* ── autoplay ── */
  var startAutoplay = function() {
    clearInterval(timerRef.current);
    timerRef.current = setInterval(function() {
      setIdx(function(i) { return i + 1; });
    }, autoplayMs || 4000);
  };
  useEffect(function() {
    startAutoplay();
    return function() { clearInterval(timerRef.current); };
  }, [perView]);

  /* ── infinite loop jump ── */
  var onTransitionEnd = function() {
    var track = trackRef.current;
    if (!track) return;
    var nextIdx = idx;
    if (idx < perView)               nextIdx = idx + total;
    else if (idx >= perView + total) nextIdx = idx - total;
    if (nextIdx !== idx) {
      skipTransition.current = true;
      setIdx(nextIdx);
    }
  };

  /* ── shared drag logic ── */
  var handleDragStart = function(clientX) {
    clearInterval(timerRef.current);
    isDragging.current  = false;
    dragStart.current   = clientX;
    dragCurrent.current = 0;
    if (wrapRef.current) wrapRef.current.classList.add("cv-dragging");
    if (trackRef.current) trackRef.current.style.transition = "none";
  };

  var handleDragMove = function(clientX) {
    if (dragStart.current === null) return;
    dragCurrent.current = clientX - dragStart.current;
    isDragging.current  = Math.abs(dragCurrent.current) > 5;
    if (isDragging.current && trackRef.current) {
      var base = idx * (cardW() + GAP);
      trackRef.current.style.transform = "translateX(" + (-(base - dragCurrent.current)) + "px)";
    }
  };

  var handleDragEnd = function() {
    if (wrapRef.current) wrapRef.current.classList.remove("cv-dragging");
    if (trackRef.current) {
      trackRef.current.style.transition = "transform 0.45s cubic-bezier(0.25,0.46,0.45,0.94)";
    }
    if (isDragging.current) {
      if      (dragCurrent.current < -50) setIdx(function(i) { return i + 1; });
      else if (dragCurrent.current >  50) setIdx(function(i) { return i - 1; });
      else moveTo(idx, true);
    }
    dragStart.current   = null;
    dragCurrent.current = 0;
    isDragging.current  = false;
    startAutoplay();
  };

  /* ── pointer (desktop) ── */
  var onPointerDown = function(e) {
    if (e.pointerType === "touch") return;
    handleDragStart(e.clientX);
    window.addEventListener("pointermove", onPointerMove);
    window.addEventListener("pointerup",   onPointerUp);
  };
  var onPointerMove = function(e) { handleDragMove(e.clientX); };
  var onPointerUp   = function() {
    window.removeEventListener("pointermove", onPointerMove);
    window.removeEventListener("pointerup",   onPointerUp);
    handleDragEnd();
  };

  /* ── touch (mobile/tablet) ── */
  var onTouchStart = function(e) { handleDragStart(e.touches[0].clientX); };
  var onTouchMove  = function(e) { e.preventDefault(); handleDragMove(e.touches[0].clientX); };
  var onTouchEnd   = function()  { handleDragEnd(); };

  useEffect(function() {
    var el = wrapRef.current;
    if (!el) return;
    el.addEventListener("touchstart", onTouchStart, { passive: true  });
    el.addEventListener("touchmove",  onTouchMove,  { passive: false });
    el.addEventListener("touchend",   onTouchEnd,   { passive: true  });
    return function() {
      el.removeEventListener("touchstart", onTouchStart);
      el.removeEventListener("touchmove",  onTouchMove);
      el.removeEventListener("touchend",   onTouchEnd);
    };
  }, [idx, perView]);

  var dotActive = ((idx - perView) % total + total) % total;

  var cardFlexBasis = "calc((100% - " + (GAP * (perView - 1)) + "px) / " + perView + ")";

  return (
    <div>
      <div
        className="cv-carousel"
        ref={wrapRef}
        onPointerDown={onPointerDown}
        style={{ touchAction: "none" }}
      >
        <div
          className="cv-carousel__track"
          ref={trackRef}
          onTransitionEnd={onTransitionEnd}
        >
          {cloned.map(function(ep, i) {
            return (
              <div
                className="cv-ep-card"
                key={i}
                style={{ flex: "0 0 " + cardFlexBasis, marginRight: GAP }}
              >
                <div className="cv-ep-card__img-wrap">
                  {ep.img && <img src={ep.img} alt={ep.ep} draggable={false} />}
                  <div className="cv-card-badge">
                    <HeadphonesIcon />
                    EV, Podcast, Top 6 episodes
                  </div>
                </div>
                <a
                  href={ep.href}
                  className="cv-ep-card__below"
                  rel="noreferrer"
                  onClick={function(e) { if (isDragging.current) e.preventDefault(); }}
                >
                  <div className="cv-ep-card__play"><PlayIcon /></div>
                  <p className="cv-ep-card__title">{ep.title}</p>
                </a>
              </div>
            );
          })}
        </div>
      </div>
      <div className="cv-dots">
        {episodes.map(function(_, i) {
          return (
            <button
              key={i}
              className={"cv-dot" + (dotActive === i ? " cv-dot--active" : "")}
              onClick={function() { setIdx(i + perView); startAutoplay(); }}
            />
          );
        })}
      </div>
    </div>
  );
}

/* ─────────────────────────────────────────────
   COUNTER STAT
───────────────────────────────────────────── */
function StatCounter({ num, label }) {
  const ref = useRef(null);
  const [displayed, setDisplayed] = useState("0");
  const hasRun = useRef(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting && !hasRun.current) {
        hasRun.current = true;
        const suffix = num.replace(/[\d.]/g, "");
        const raw    = num.replace(/[^0-9.]/g, "");
        const target = parseFloat(raw);
        const isK    = suffix.includes("k");
        const duration = 1200;
        const steps    = 40;
        const interval = duration / steps;
        let step = 0;
        const timer = setInterval(() => {
          step++;
          const progress = step / steps;
          const eased    = 1 - Math.pow(1 - progress, 3);
          const val      = Math.round(eased * target);
          setDisplayed(isK ? val + "k+" : val + "+");
          if (step >= steps) { clearInterval(timer); setDisplayed(num); }
        }, interval);
      }
    }, { threshold: 0.3 });
    obs.observe(el);
    return () => obs.disconnect();
  }, [num]);

  return (
    <div className="cv-stat" ref={ref}>
      <span className="cv-stat__num">{displayed}</span>
      <span className="cv-stat__label">{label}</span>
    </div>
  );
}

/* ─────────────────────────────────────────────
   INTERSECTION OBSERVER HOOK
───────────────────────────────────────────── */
function useReveal(selector) {
  const ref = useRef(null);
  useEffect(() => {
    if (!ref.current) return;
    const els = ref.current.querySelectorAll(selector);
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add("cv-visible"); obs.unobserve(e.target); }
      }),
      { threshold: 0.1 }
    );
    els.forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, [selector]);
  return ref;
}

/* ─────────────────────────────────────────────
   ROOT
───────────────────────────────────────────── */
export default function ConversationsPage() {
  const [activeTab, setActiveTab] = useState(2);
  const trendingRef = useReveal(".cv-simple-card");
  const latestRef   = useReveal(".cv-simple-card");
  const guestRef    = useReveal(".cv-guest-card");

  return (
    <>
      <style>{CSS}</style>
      <div className="cv-page">

        {/* ── SECTION 1: HERO ── */}
        <section className="cv-hero">
          <div className="cv-inner">
            <h1 className="cv-hero__title">
              ENERGIZING INDIA
              <span>Podcast</span>
            </h1>
            <img src={ConversationsMicLogo} alt="Podcast Mic" className="cv-hero__mic" />
            <Carousel episodes={HERO_EPISODES} autoplayMs={4000} />
          </div>
          <div className="cv-hero__divider" />
        </section>

        {/* ── SECTION 2: TOP 6 TRENDING ── */}
        <section className="cv-trending">
          <div className="cv-inner">
            <p className="cv-section-label">Trending Music</p>
            <h2 className="cv-section-title">Top 6 Trending Music This Month</h2>
            <p className="cv-section-sub">We've made your navigation task easy! Find the Star episodes below, so that you don't miss out the spark!</p>
            <div className="cv-grid-3" ref={trendingRef}>
              {TRENDING_EPISODES.map((ep, i) => (
                <SimpleCard key={i} {...ep} />
              ))}
            </div>
          </div>
          <div className="cv-trending__divider" />
        </section>

        {/* ── SECTION 3: MOBILE STREAM ── */}
        <section className="cv-mobile">
          <div className="cv-mobile__img-wrap">
            <img src={ConversationsMobileImg} alt="Energizing India on mobile" />
          </div>
          <div className="cv-mobile__content">
            <span className="cv-mobile__label">Available On Mobile</span>
            <h2 className="cv-mobile__title">Now You Can Online Stream Through Your Phone</h2>
            <p className="cv-mobile__desc">Energizing India Podcast focuses on electric vehicle mobility in India, the E-Mobility industry, and how rapid change can be brought about to grow this industry.</p>
            <div className="cv-mobile__btns">
              <a href="https://open.spotify.com/show/31CpjZm9DyfCR7sstBZlIf" target="_blank" rel="noreferrer">
                <img src={ConversationsSpotifyBtn} alt="Listen on Spotify" />
              </a>
              <a href="https://podcasts.apple.com/in/podcast/energizing-india-podcast/id1530917254" target="_blank" rel="noreferrer">
                <img src={ConversationsAppleBtn} alt="Download on App Store" />
              </a>
            </div>
          </div>
        </section>

        {/* ── SECTION 4: TABS + LATEST EPISODES ── */}
        <section className="cv-latest">
          <div className="cv-tabs-wrap">
            <div className="cv-tabs-inner">
              <div className="cv-tabs">
                {TABS.map((tab, i) => (
                  <a
                    key={i}
                    href={tab.href}
                    className={"cv-tab" + (activeTab === i ? " cv-tab--active" : "")}
                    onClick={() => setActiveTab(i)}
                  >
                    {tab.label}
                    <span className="cv-tab__sub">Check it Now</span>
                  </a>
                ))}
              </div>
            </div>
          </div>
          <div className="cv-inner">
            <div className="cv-latest__header">
              <h2 className="cv-latest__heading">OUR LATEST EPISODES</h2>
              <a href="/all-episodes/" className="cv-latest__viewall" rel="noreferrer">
                View All Episodes <ArrowRight />
              </a>
            </div>
            <div ref={latestRef}>
              <Carousel episodes={LATEST_EPISODES} autoplayMs={5000} />
            </div>
          </div>
        </section>

        {/* ── SECTION 5: SPOTIFY IFRAMES ── */}
        <section className="cv-spotify">
          <div className="cv-inner">
            <div className="cv-spotify__list">
              <iframe className="cv-spotify__iframe" src={SPOTIFY_EMBEDS[0]} height="152" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" title="Spotify episode 1" />
              <iframe className="cv-spotify__iframe" src={SPOTIFY_EMBEDS[1]} height="352" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" title="Spotify show" />
              <div className="cv-spotify__row2">
                <iframe className="cv-spotify__iframe" src={SPOTIFY_EMBEDS[2]} height="152" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" title="Spotify episode 3" />
                <iframe className="cv-spotify__iframe" src={SPOTIFY_EMBEDS[3]} height="152" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" title="Spotify episode 4" />
              </div>
              <div className="cv-spotify__row2">
                <iframe className="cv-spotify__iframe" src={SPOTIFY_EMBEDS[4]} height="152" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" title="Spotify episode 5" />
                <iframe className="cv-spotify__iframe" src={SPOTIFY_EMBEDS[0]} height="152" allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture" loading="lazy" title="Spotify episode 6" />
              </div>
            </div>
          </div>
        </section>

        {/* ── SECTION 6: FEATURED SHOWS + GUESTS ── */}
        <section className="cv-featured">
          <div className="cv-inner">
            <p className="cv-featured__label">Listing Podcast</p>
            <h2 className="cv-featured__title">Featured Shows</h2>
            <div className="cv-featured__stats">
              {[
                { num: "60+",  label: "Episodes"  },
                { num: "18k+", label: "Downloads" },
                { num: "18+",  label: "GUEST"     },
                { num: "10+",  label: "Countries" },
              ].map((s, i) => (
                <StatCounter key={i} num={s.num} label={s.label} />
              ))}
            </div>
            <div className="cv-guest-header">
              <h3 className="cv-guest-title">Our Guest</h3>
              <p className="cv-guest-label">Choose Guest For listening Podcast</p>
            </div>
            <div className="cv-guest__grid" ref={guestRef}>
              {GUESTS.map((g, i) => (
                <div key={i} className="cv-guest-card">
                  <div className="cv-guest-card__img">
                    <img src={g.img} alt={g.name} />
                  </div>
                  <div className="cv-guest-card__name">{g.name}</div>
                </div>
              ))}
            </div>
          </div>
        </section>

      </div>
    </>
  );
}